<template>
  <div>
    <ContentHeader :show-back="false" />
    <div class="content-container" v-loading="listLoading">
      <el-table :data="cartItemList" ref="cartItemForm" class="while-data-table" @selection-change="handleSelectChange">
        <el-table-column :selectable="checkRowSelectable" type="selection" width="30" />
        <el-table-column label="图片">
          <template slot-scope="scope">
            <div class="item-image">
              <img :src="getImageUrl(scope.row.pocmDTO)" />
            </div>
          </template>
        </el-table-column>
        <el-table-column label="商品">
          <template slot-scope="scope">
            <span class="item-name">{{ scope.row.pocmDTO.itemName }}</span>
            <span v-if="!scope.row.pocmDTO.itemStatus" class="un-publish">(已下架)</span>
          </template>
        </el-table-column>
        <el-table-column label="品牌" show-overflow-tooltip>
          <template slot-scope="scope">{{ getBrandShow(scope.row) }}</template>
        </el-table-column>
        <el-table-column label="品牌组" prop="subBrandGroup" show-overflow-tooltip />
        <!-- <el-table-column label="渠道" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>
              {{ scope.row.channelName }}
              <span v-if="scope.row.subChannelName">
                {{ '-' + scope.row.subChannelName }}
              </span>
            </span>
          </template>
        </el-table-column>-->
        <el-table-column label="工厂" prop="companyEntityName" />
        <el-table-column label="MMR12" prop="mmr12" width="60" />
        <el-table-column label="价格(不含税)">
          <template slot-scope="scope">
            <div>￥{{ getPrice(scope.row.pocmDTO) | thousandSymbol}}</div>
            <div
              class="price-msg"
              v-if="scope.row.pocmDTO.priceUnitQuantity !== 1"
            >(每{{ scope.row.pocmDTO.priceUnitQuantity | thousandSymbol}}个商品{{ getPrice(scope.row.pocmDTO) | thousandSymbol}}元)</div>
          </template>
        </el-table-column>
        <el-table-column label="税额">
          <template slot-scope="scope">
            <div v-if="scope.row.pocmDTO.pocmPriceType === '01'">￥{{ getTaxPrice(scope.row.pocmDTO) | thousandSymbol}}</div>
            <div v-else>￥ 0.00</div>
            <div
              class="price-msg"
              v-if="scope.row.pocmDTO.priceUnitQuantity !== 1 && scope.row.pocmDTO.pocmPriceType === '01'"
            >(每{{ scope.row.pocmDTO.priceUnitQuantity | thousandSymbol}}个商品{{ getTaxPrice(scope.row.pocmDTO) | thousandSymbol}}元)</div>
          </template>
        </el-table-column>
        <el-table-column label="运费" prop="pocmDTO.extraFee">
          <template slot-scope="scope">
            <div>￥{{ scope.row.pocmDTO.extraFee | thousandSymbol}}</div>
            <div
              class="price-msg"
              v-if="scope.row.pocmDTO.priceUnitQuantity !== 1 && scope.row.pocmDTO.extraFee !== 0"
            >(每{{ scope.row.pocmDTO.priceUnitQuantity | thousandSymbol}}个商品{{ scope.row.pocmDTO.extraFee | thousandSymbol}}元)</div>
          </template>
        </el-table-column>
        <el-table-column label="起订量" prop="pocmDTO.factoryMOQ" width="70">
          <template slot-scope="scope">{{scope.row.pocmDTO.factoryMOQ | thousandSymbol}}</template>
        </el-table-column>
        <el-table-column label="数量" min-width="100px">
          <template slot-scope="scope">
            <el-input-number v-model="scope.row.itemQuantity" size="mini" :min="1" @change="quantityChange(scope.row)" />
          </template>
        </el-table-column>
        <el-table-column label="价格小计" width="70">
          <template slot-scope="scope">￥{{ getItemSumPrice(scope.row) | thousandSymbol}}</template>
        </el-table-column>
        <el-table-column label="税额小计" width="70">
          <template slot-scope="scope">￥{{ getItemSumTaxPrice(scope.row) | thousandSymbol}}</template>
        </el-table-column>
        <el-table-column label="运费小计" width="70">
          <template slot-scope="scope">￥{{ getItemSumExtraPrice(scope.row) | thousandSymbol}}</template>
        </el-table-column>
        <el-table-column label="操作" width="80">
          <template slot-scope="scope">
            <div class="icon-star">
              <span v-if="scope.row.pocmDTO.isStandard">
                <i class="iconfont iconzu16 cursor" title="加入常用物料" v-if="!scope.row.pocmDTO.isFavorite" @click="inFavorite(scope.row)"></i>
                <i class="iconfont iconzu211 cursor" title="取消加入常用物料" v-else @click="outFavorite(scope.row)"></i>
              </span>
              <i
                class="iconfont iconzu17 cursor"
                :class="{'iconzu17-none': !scope.row.pocmDTO.isStandard}"
                title="删除商品"
                @click="deleteRowItem(scope.row)"
              ></i>
            </div>
          </template>
        </el-table-column>
      </el-table>

      <el-row v-if="cartItemList.length" class="while-data-table-footer cart-footer">
        <el-col :span="1">
          <el-checkbox v-model="allChecked" @change="onAllChecked" />
        </el-col>
        <el-col :span="11" class="text-left">全选</el-col>
        <el-col :span="12" class="text-right">
          <span class="cart-footer-opt" @click="deleteItem">删除选中商品</span>
        </el-col>
      </el-row>

      <div class="cart-item-list">
        <div class="summary-line">
          <div class="text">
            商品共
            <span class="text-underline">{{ totalCount }}</span> 件
          </div>
          <div class="text">
            已选择
            <span class="text-underline">{{ selectedCount }}</span> 件
          </div>
          <div class="text">
            商品合计
            <span class="text-underline">￥{{ totalAmount | thousandSymbol}}</span>
          </div>
          <!-- <div class="text">应扣除预算 <span class="text-underline deduct-amount">￥{{ deductAmount }}</span></div> -->
        </div>

        <div class="button-line">
          <el-button class="btn-red" @click="doSettlement">
            下单结算
            <i class="iconfont iconzu121" />
          </el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ContentHeader from '../../components/content-header'
import { commonUtils } from '@/utils/common'
import { create, all } from 'mathjs/number'
const math = create(all)
export default {
  name: 'cart-list',
  components: {
    ContentHeader
  },
  data () {
    return {
      allChecked: false,
      cartItemList: [],
      listLoading: false,
      itemQuantity: 0
    }
  },
  computed: {
    totalCount () {
      return this.cartItemList ? this.cartItemList.length : 0
    },
    selectedCount () {
      let count = 0
      if (!this.cartItemList) {
        return null
      }
      this.cartItemList.map(item => {
        if (item.checked) {
          count++
        }
      })
      return count
    },
    // 商品合计
    // totalAmount () {
    //   let total = 0
    //   let hasChecked = false
    //   this.cartItemList.map(item => {
    //     if (item.checked) {
    //       hasChecked = true
    //       let price = item.pocmDTO.purchasePrice
    //       if (item.pocmDTO.pocmPriceType === '02') price = item.pocmDTO.taxExcludedPrice
    //       const rowPriceSum = Number(math.multiply(item.itemQuantity / item.pocmDTO.priceUnitQuantity, price).toFixed(2))
    //       const rowExtraSum = Number(math.multiply(item.itemQuantity / item.pocmDTO.priceUnitQuantity, item.pocmDTO.extraFee).toFixed(2))
    //       const rowSum = math.add(rowPriceSum, rowExtraSum)
    //       total = math.add(total, rowSum)
    //     }
    //   })
    //   let sum = Number(commonUtils.formatNumber(total)).toFixed(2)
    //   if (hasChecked) {
    //     sum = Number(sum) ? sum : 0.01
    //   }
    //   return sum
    // },
    // 商品合计 新逻辑：含税价/未税价*数量总和
    totalAmount () {
      let total = 0
      let hasChecked = false
      this.cartItemList.map(item => {
        if (item.checked) {
          hasChecked = true
          let price = item.pocmDTO.purchasePrice
          if (item.pocmDTO.pocmPriceType === '02') price = item.pocmDTO.taxExcludedPrice

          // 单行价格
          const rowPriceSum = Number(math.multiply(item.itemQuantity / item.pocmDTO.priceUnitQuantity, price).toFixed(2))

          total += rowPriceSum
        }
      })
      let sum = Number(commonUtils.formatNumber(total)).toFixed(2)
      if (hasChecked) {
        sum = Number(sum) ? sum : 0.01
      }
      return sum
    },

    deductAmount () {
      return this.totalAmount
    }
  },
  created () {
    this.queryCartList()
  },
  methods: {

    // 获取购物车列表
    queryCartList () {
      this.listLoading = true
      this.$store.dispatch('queryCartList').then(res => {
        this.listLoading = false
        if (res.data.resultCode === '0') {
          this.cartItemList = res.data.resultData.quotaShoppingCartList || []
          this.cartItemList.forEach(item => {
            this.$set(item, 'checked', false)
          })
        }
      }).catch(() => {
        this.listLoading = false
      })
    },
    // 获取图片
    getImageUrl (item) {
      let imageUri = ''
      if (item.imageList && item.imageList.length > 0) {
        imageUri = item.imageList[0].imageFileUri
      }
      return commonUtils.getImageUrl(imageUri)
    },
    onAllChecked () {
      this.$refs.cartItemForm.toggleAllSelection()
    },
    onItemChecked (val) {
      let list = []
      this.cartItemList.map(item => {
        if (item.pocmDTO.itemStatus) {
          list.push(item)
        }
      })
      let allChecked = true
      list.map(item => {
        if (!item.checked) {
          allChecked = false
        }
      })
      this.allChecked = allChecked
    },
    // 额外费用合计
    getItemSumExtraPrice (item) {
      if (!item) {
        return ''
      }
      item.sumPrice = commonUtils.formatNumber(math.multiply(item.pocmDTO.extraFee, item.itemQuantity / item.pocmDTO.priceUnitQuantity)).toFixed(2)
      item.sumPrice = Number(item.sumPrice)
      return item.sumPrice
    },
    // 单行合计
    getItemSumPrice (item) {
      if (!item) {
        return ''
      }
      // let price = item.pocmDTO.purchasePrice
      // if (item.pocmDTO.pocmPriceType === '02') price = item.pocmDTO.taxExcludedPrice
      item.sumPrice = commonUtils.formatNumber(math.multiply(item.pocmDTO.taxExcludedPrice, item.itemQuantity / item.pocmDTO.priceUnitQuantity)).toFixed(2)
      item.sumPrice = Number(item.sumPrice)
      return item.sumPrice
    },
    // 税额小计
    getItemSumTaxPrice (item) {
      item.pocmDTO.taxRate = item.pocmDTO.taxRate ? item.pocmDTO.taxRate : 0
      if (item.pocmDTO.pocmPriceType === '02') return 0
      let taxPrice = commonUtils.formatNumber(math.multiply(item.pocmDTO.taxRate, item.pocmDTO.taxExcludedPrice)).toFixed(2)
      let price = commonUtils.formatNumber(math.multiply(taxPrice, item.itemQuantity / item.pocmDTO.priceUnitQuantity)).toFixed(2)
      if (Number(price) < 0.01) price = 0.00
      return price
    },
    // 选中项改变时，让被选中item的checked为true
    handleSelectChange (selectedItem) {
      if (!selectedItem) {
        this.$refs.cartItemForm.clearSelection()
        return
      }
      this.cartItemList.map(item => {
        item.checked = false
      })
      selectedItem.forEach(selected => {
        this.cartItemList.forEach((cartItem, index) => {
          if (selected.cartId === cartItem.cartId) {
            this.cartItemList[index].checked = true
          }
        })
      })
      this.onItemChecked()
    },
    // 加入常用物料
    inFavorite (row) {
      this.listLoading = true
      const params = { itemId: row.itemId }
      this.$store.dispatch('createFavItem', params).then(res => {
        this.listLoading = false
        if (res.data.resultCode === '0') {
          this.listLoading = false
          this.$message.success('成功加入我的常用物料')
          this.queryCartList()
        }
      }).catch(() => {
        this.listLoading = false
      })
    },
    // 取消加入常用物料
    outFavorite (row) {
      this.listLoading = true
      const id = row.pocmDTO.favoriteItemDTO.favoriteId
      this.$store.dispatch('deleteFacItem', id).then(res => {
        this.listLoading = false
        if (res.data.resultCode === '0') {
          this.listLoading = false
          this.$message.success('取消成功')
          this.queryCartList()
        }
      }).catch(() => {
        this.listLoading = false
      })
    },

    // 选择商品排序
    compare (prop) {
      return function (a, b) {
        let a1 = a[prop]
        let b1 = b[prop]
        return a1 - b1
      }
    },

    // 下单结算
    doSettlement () {
      let cartIdList = []
      let cartList = []
      let checkResult = true
      if (this.cartItemList.length > 0) {
        this.cartItemList.forEach(item => {
          // push item
          if (item.checked) {
            cartList.push(item)
            cartIdList.push(item.cartId)
          }
        })
        // 以itemId 商品排序
        cartList.sort(this.compare('itemId'))

        if (cartList.length > 0) {
          let menuItem = 0
          let NonMenuItem = 0
          for (let i = 0; i < cartList.length; i++) {
            if (cartList[i + 1] && cartList[i].companyEntityId !== cartList[i + 1].companyEntityId) {
              this.$message.error('不同工厂的物料不能同时下单')
              return
            }
            if (cartList[i].pocmDTO.isStandard) {
              menuItem++
            } else {
              NonMenuItem++
            }

            if (cartList[i + 1] && cartList[i].itemId === cartList[i + 1].itemId) {
              if ((cartList[i].abiBrandId !== cartList[i + 1].abiBrandId) || (cartList[i].subBrandId !== cartList[i + 1].subBrandId)) {
                this.$message.error('同一商品不同品牌不能同时下单')
                return
              }
            }
          }

          if (menuItem > 0 && NonMenuItem > 0) {
            checkResult = false
          }
        } else {
          this.$message.error('暂无可操作商品，请勾选商品')
          return
        }

        if (!checkResult) {
          this.$message.error('menu与non-menu商品不能一同下单')
          return
        }
        this.listLoading = true
        this.$store.dispatch('cartSettlement', cartIdList).then(res => {
          this.listLoading = false
          if (res.data.resultCode === '0') {
            this.$router.push({
              path: '/material/fill-order',
              query: { type: 'cart' }
            })
          }
        }).catch(() => {
          this.listLoading = false
          this.$message.error('下单失败')
        })
      }
    },
    // 右下角删除商品
    deleteItem () {
      let count = 0
      let api
      let params
      const selectedItemId = []
      this.cartItemList.map(item => {
        if (item.checked) {
          count++
          selectedItemId.push(item.cartId)
        }
      })
      if (count === 1) {
        api = 'deleteCart'
        params = selectedItemId[0]
      } else if (count > 1) {
        api = 'deleteCarts'
        params = { cartIds: selectedItemId.join(',') }
      } else if (count === 0) {
        this.$message.error('暂无可操作商品，请勾选商品')
        return
      }
      this.listLoading = true
      this.$store.dispatch(api, params).then(res => {
        this.listLoading = false
        if (res.data.resultCode === '0') {
          this.$message.success('删除商品成功')
          this.$refs.cartItemForm.clearSelection()
          this.queryCartList()
        }
      }).catch(() => {
        this.listLoading = false
        this.$message.error('删除商品失败')
      })
    },
    // 单行删除商品
    deleteRowItem (row) {
      row.checked = false
      let count = 0
      this.listLoading = true
      this.$store.dispatch('deleteCart', row.cartId).then(res => {
        this.listLoading = false
        if (res.data.resultCode === '0') {
          this.cartItemList.forEach((item, index) => {
            if (item.cartId === row.cartId) {
              this.cartItemList.splice(index, 1)
            }
          })
          this.cartItemList.forEach(item => {
            if (item.checked) {
              count++
            }
          })
          if (count === 0) {
            this.$refs.cartItemForm.clearSelection()
          }
          this.$message.success('删除商品成功')
        }
      }).catch(() => {
        this.listLoading = false
        this.$message.error('删除商品失败')
      })
    },
    // 数量改变时触发
    quantityChange (row) {
      if (!row.itemQuantity) {
        this.queryCartList()
        this.$message.error('数量为空，请重新操作')
        return false
      }
      this.$nextTick(() => {
        // if (row.itemQuantity % row.pocmDTO.priceUnitQuantity !== 0) {
        //   this.$message.error(`仅支持以${row.pocmDTO.priceUnitQuantity}倍数量购买`)
        //   row.itemQuantity = oldValue
        //   return
        // }
        this.$store.dispatch('updateCart', row).then(res => {
          if (res.data.resultCode === '0') { }
        }).catch(() => {
          this.$message.error('修改数量失败')
        })
      })
    },

    getPrice (item) {
      if (!item.taxExcludedPrice) return
      return (item.taxExcludedPrice).toFixed(2)
    },
    // 计算税额
    getTaxPrice (item) {
      return (item.taxRate * item.taxExcludedPrice).toFixed(2)
    },

    // 是否已下架
    checkRowSelectable (row) {
      if (!row.pocmDTO.itemStatus) {
        return false
      }
      return true
    },
    getBrandShow (row) {
      // 主品牌 - 子品牌
      return `${row.abiBrandName || ''} ${row.subAbiBrandName ? '-' : ''} ${row.subAbiBrandName || ''}`
    }
  }
}
</script>

<style lang="scss" scoped>
.el-input-number--mini {
  width: 100px;
}
.price-msg {
  padding: 0 5px;
}
.icon-star {
  display: inline-block;
  font-size: 26px;
  height: 26px;
  line-height: 26px;
  .iconfont {
    font-size: 25px;
  }
  .iconzu16 {
    color: $base-grey4;
  }
  .iconzu17 {
    color: $base-grey4;
    padding-left: 5px;
  }
  .iconzu211 {
    color: $base-red;
  }
  // .iconzu17-none {
  //   padding-left: 30px;
  // }
}
.cart-item-list {
  margin-top: 24px;
  text-align: center;

  .list-header {
    color: $base-plain;
    line-height: 48px;
    background-color: $base-white;

    &:first-child {
      border-top-left-radius: 8px;
    }

    &:last-child {
      border-top-right-radius: 8px;
    }
  }
}

.cart-footer {
  margin-top: 16px;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  height: 48px;
  background-color: $base-white;
  padding: 16px 0;

  .cart-footer-opt {
    color: $base-plain;
    margin-right: 20px;
    cursor: pointer;
  }
}

.summary-line {
  margin-top: 16px;
  background-color: $base-lightpink;
  border-radius: 8px;
  height: 36px;
  padding: 24px 0 0 0;

  .text {
    display: inline-block;
    line-height: 16px;
    margin: 0 10px;

    .deduct-amount {
      color: $base-red;
      font-size: $font-20;
      font-weight: 700;
    }
  }
}

.button-line {
  height: 80px;
  padding-top: 30px;
}

.un-publish {
  color: $base-red;
  padding-left: 5px;
  font-weight: bold;
}

.item-image {
  width: 60px;
  height: 60px;
  margin: 0 auto;
  border: 1px solid $base-grey;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  img {
    max-width: 95%;
    max-height: 95%;
    border: none;
  }
}

.iconzu121 {
  font-size: 18px;
}
.price-info {
  font-size: 12px;
  color: #999;
}
</style>
